import ApiError from '../../../../entities/api-error/ApiError'
import { Column } from '../../../../entities/column/Column'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestDashboard {
  type: DashboardActionTypes.REQUEST_DASHBOARD;
  payload: {
    date:                   Date;
    shouldResetOpenCycles?: boolean;
  }
}

export function requestDashboard({
  date,
  shouldResetOpenCycles,
}: RequestDashboard['payload']): RequestDashboard {
  return {
    type: DashboardActionTypes.REQUEST_DASHBOARD,
    payload: {
      date,
      shouldResetOpenCycles: shouldResetOpenCycles || false,
    },
  }
}

export interface RequestDashboardSuccess {
  type: DashboardActionTypes.REQUEST_DASHBOARD_SUCCESS;
  payload: {
    columns:                Column[];
    shouldResetOpenCycles?: boolean;
  }
}

export function requestDashboardSuccess({
  columns,
  shouldResetOpenCycles,
}: RequestDashboardSuccess['payload']): RequestDashboardSuccess {

  return {
    type: DashboardActionTypes.REQUEST_DASHBOARD_SUCCESS,
    payload: {
      columns,
      shouldResetOpenCycles: shouldResetOpenCycles || false,
    },
  }
}

export interface RequestDashboardFailure {
  type: DashboardActionTypes.REQUEST_DASHBOARD_FAILURE;
  payload: {
    date:   Date;
    error:  ApiError;
  }
}

export function requestDashboardFailure({
 date,
 error,
}: RequestDashboardFailure['payload']): RequestDashboardFailure {

  return {
    type: DashboardActionTypes.REQUEST_DASHBOARD_FAILURE,
    payload: {
      date,
      error,
    },
  }
}
